import { z } from 'zod';
/**
 * What `GET /api/version` returns.
 *
 * `dbMigration` is the point of this endpoint. Version and SHA tell you what
 * code is running; the migration name tells you what shape the database is in.
 * When a deploy half-lands — new image, migration never applied — those two
 * disagree, and that mismatch is visible here instead of surfacing later as an
 * unexplained 500 in the middle of a label run.
 */
export const versionInfoSchema = z.object({
    /** Semver from the root package.json, e.g. "1.4.2". */
    version: z.string(),
    /** Short git SHA baked in at image build time, e.g. "a1b2c3d". "dev" when running locally. */
    gitSha: z.string(),
    /** ISO timestamp of the image build. */
    builtAt: z.string(),
    /** Name of the most recently applied Prisma migration, or null if the DB is unreachable. */
    dbMigration: z.string().nullable(),
    /** True when the API is pointed at a Shippo test token, so the UI can shout about it. */
    /** Derived from the API key in use, not from a flag that could disagree. */
    shippoMode: z.enum(['test', 'live', 'unknown']),
    /** The same for the EasyPost key, derived from its prefix. */
    easypostMode: z.enum(['test', 'live', 'unknown']),
    /** Which API buys new Mail-page labels. The banner reports this one's mode. */
    shippingProvider: z.enum(['shippo', 'easypost']),
    /**
     * Whether labels can actually be saved to the data volume.
     *
     * Here because the failure is otherwise invisible: the app starts cleanly,
     * rates quote, labels buy, and only the archive is empty. That is how the
     * first label bought in production came to have no copy kept for it.
     */
    labelStorage: z.enum(['ok', 'unwritable', 'unknown']),
});
/** Human-readable build stamp for the sidebar footer: "v1.4.2 · a1b2c3d". */
export function formatBuildStamp(info) {
    return `v${info.version} · ${info.gitSha}`;
}
//# sourceMappingURL=version.js.map